// Portal <-> extension stitch bridge: window CustomEvents and background messages.
// Event names and payload shapes are shared with apps/extension and apps/portal.
export const EVENT_SET_STITCH_CONTEXT = 'cricket-studio:set-stitch-context';
export const EVENT_CLEAR_STITCH_CONTEXT = 'cricket-studio:clear-stitch-context';
export const EVENT_STITCH_CONTEXT_ACK = 'cricket-studio:stitch-context-ack';
/**
 * Runtime guard for portal-issued stitch context. Invalid pages should not pass arbitrary objects
 * to the content script.
 */
export function isSetStitchContextDetail(value) {
    if (!value || typeof value !== 'object')
        return false;
    const o = value;
    if (typeof o.flowId !== 'string' || o.flowId.trim().length === 0) {
        return false;
    }
    if (typeof o.flowTitle !== 'string') {
        return false;
    }
    if (typeof o.expectedParentUpdatedAt !== 'string') {
        return false;
    }
    if (o.uploadToken !== undefined && typeof o.uploadToken !== 'string') {
        return false;
    }
    if (o.insertPosition !== 'before' && o.insertPosition !== 'after') {
        return false;
    }
    const anchor = o.anchorEventIndex;
    if (typeof anchor !== 'number' || !Number.isInteger(anchor) || anchor < 0) {
        return false;
    }
    return true;
}
